import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type TASProgramTemplateModel from 'tio-data/models/tas-program-template';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type PartnerService from 'tio-employee/services/partner';

export default class AuthenticatedAdminTuitionAssistanceDashboardRoute extends Route {
  @service declare store: StoreService;
  @service declare partner: PartnerService;

  async model() {
    const templates = await this.store.query<TASProgramTemplateModel>('tas-program-template', {
      // @ts-expect-error fix filter
      filter: {
        state: 'TAS.ProgramTemplateState.LAUNCHED',
        company: this.partner.company?.id,
        isTrial: 'true,false',
      },
    });

    return {
      templates,
    };
  }
}
